export default "__VITE_ASSET__DhfMaiSA__"